import { promoToastFor } from './promo-toast';
import type { PromoOutcome } from './promo-outcome';

export interface PromoFormMessage {
  key: string;
  tone: 'success' | 'info' | 'error';
  values?: Record<string, number>;
  /** The code is spent or dead: clear the field. Otherwise keep it so the user can fix or retry. */
  clearInput: boolean;
}

/**
 * What the Settings "Redeem a code" form says after an attempt.
 *
 * Unlike the campaign-link toast, every outcome speaks here: the reader typed the code and is
 * waiting on the answer, so `retry`/`failed` cannot be silent. A used-up code (`exhausted`) gets its
 * own line, "no longer available", because "this offer has ended" reads wrong for a code whose
 * campaign is still running for others.
 */
export function promoFormMessage(outcome: PromoOutcome, credits: number, freeHours: number): PromoFormMessage {
  switch (outcome) {
    case 'redeemed':
    case 'already':
    case 'expired':
    case 'unknown': {
      const toast = promoToastFor(outcome, credits, freeHours);
      if (toast) {
        return {
          key: toast.key,
          tone: toast.severity === 'success' ? 'success' : toast.severity === 'error' ? 'error' : 'info',
          values: toast.values,
          clearInput: outcome !== 'unknown',
        };
      }
      break;
    }
    case 'exhausted':
      return { key: 'settings.promo.exhausted', tone: 'info', clearInput: true };
    default:
      break;
  }
  return { key: 'settings.promo.failed', tone: 'error', clearInput: false };
}
